import React from 'react'
import { useTrans } from 'hooks'
import { PaginaNode } from '@gql/graphql'
import { Page, PageNotFoundHead } from 'components/organisms'
import styles from './PageNotFoundTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
}

const PageNotFoundTemplate = (props: Props) => {
  const { pagina = undefined } = props

  const t = useTrans()

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <PageNotFoundHead
          item={{
            name: t('Questa pagina non è raggiungibile '),
            description: t(
              '<p>La pagina che stai cercando non è disponibile, ma il nostro sito ti offre altre risorse utili. Ti invitiamo a consultare il menu o a contattarci tramite l’<a href="/contatti/">apposito modulo</a>: saremo lieti di aiutarti a trovare ciò di cui hai bisogno.</p>'
            ),
            ctaLabel: t("Torna all'homepage"),
            url: '/',
            image: `/${process.env.SITE}/404.jpg`,
          }}
        />
      </main>
    </Page>
  )
}

export default PageNotFoundTemplate
